export class ThermalMethod {
  methodName: string;

  constructor(row: Record<string, string>) {
    this.methodName = row['methodName'] as string;
  }
}